import type { HeaderColorEnum } from '@/service/__generated-api'

export default function useHeaderColor() {
  return useState<HeaderColorEnum>('headerColor', () => 'brown')
}
